import { render, staticRenderFns } from "./Default.vue?vue&type=template&id=65b6ebb0&scoped=true"
import script from "./Default.vue?vue&type=script&lang=ts"
export * from "./Default.vue?vue&type=script&lang=ts"
import style0 from "./Default.vue?vue&type=style&index=0&id=65b6ebb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b6ebb0",
  null
  
)

export default component.exports